export type UsernameType = {
  memberId?: string;
  email?: string;
  keep_signed: number;
};

export type AuthType = {
  clid: number;
  token: string;
};

export type PasswordType = {
  pass: string;
};

export type LoginTypes = UsernameType & PasswordType;

export type IUser = {
  id: number;
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  nickname: string;
  givname: string;
  surname: string;
  ph_mobile: string;
  ph_home: string;
  ph_work: string;
  bday_date: string;
  date_start: string;
  cl_photo: string;
  photo: string;
  gender: string;
  gift_cards_balance: number;
  membership_bank_balance: number;
  is_member: boolean;
  is_vip: number;
  is_influencer: number;
  home_store_id: number;
  pronoun?: string | null;
  is_new_client?: number;
  balance?: number;
  olb: {
    allow_cancel?: number;
    allow_cancel_hrs?: number;
    allow_move?: number;
    allow_move_hrs?: number;
    req_ccard?: number;
    send_confirm?: number;
  };
  olgc: {
    allow_gc_purchase?: number;
    show_gratuity?: number;
  };
};

export type GenderFormType = {
  pronoun_id?: number | string;
  nickname?: string;
  gender?: string | null;
};

export type FormType = {
  email: string;
  givname: string;
  surname: string;
  ph_mobile: string;
  bday_date: string;
  postal: string;
  ref_code: string;
  campaign_id: string;
};

export type GenderType = 'M' | 'F' | '';

export interface GenderInterface {
  label: string;
  value: GenderType;
}

export interface UserInfo {
  clid: number;
  email: string;
  error: string;
  http_code: number;
  memberid: string;
  name: string;
  service_contact: string;
  success: boolean;
  token: string;
}

export type CheckMembershipType = {
  email?: string;
  clientid?: string;
  bday: string;
};

export type MemberData = {
  bday_date: string;
  clid: number;
  contact_phone: string;
  email: string;
  first_name: string;
  is_active: boolean;
  last_name: string;
  mail_sent: boolean;
  name: string;
  nickname: string;
  ph_mobile: string;
  sms_sent: boolean;
  success: boolean;
};

export type AccessCodeParams = {
  email?: string;
  memberid?: number;
  clientid?: number;
  bday: string;
  type: SentType;
};

export type CheckAccessCodeParams = {
  clientid: number | string;
  access_code: string;
};

export type SentType = 'sms' | 'email';

export type CheckEmailParams = {
  email: string;
  phone?: string;
  givname?: string;
  bday?: string;
  onResetFlow?: () => void;
};

export enum CreateAccountSteps {
  AccountForm,
  Personalization,
  CreatePassword
}

export type FormField = {
  id: number;
  name: string;
};

export type RefCodeResponse = {
  is_valid?: number;
  ld_ref_type?: number;
  ld_ref_acct?: number;
  ref_code?: string;
};

export type ClientReferenceType = {
  ref_code: string;
  ref_title: string;
  ref_dscr: string;
  ref_opts: {
    line1: string;
    line2: string;
    line3: string;
  };
};
